import * as ActionTypes from '../ActionTypes';

export const GetReportScheduleAction = (params) => {
    return {
        type: ActionTypes.REPORT_SCHEDULE_GET_REQUEST,
        params, 
    };
};

export const UpdateReportScheduleAction = (params) => {
    return {
        type: ActionTypes.REPORT_SCHEDULE_UPDATE_REQUEST,
        params,
    };
};

export const DeleteReportScheduleAction = (params) => {
    return {
        type: ActionTypes.REPORT_SCHEDULE_DELETE_REQUEST,
        params,
    };
};